import { memo } from "react";
import { Div, Icon, Text, useTheme, type DivProps, type OmitProps } from "react-better-html";

import { type OrganizationType } from "../../types/organization";

import { useI18n } from "../../utils/i18n";

import DecorationCard from "./DecorationCard";

type DecorationOrganizationNameCardProps = OmitProps<DivProps, "children"> & {
   organizationName?: string;
   organizationType?: OrganizationType;
};

function DecorationOrganizationNameCard({
   organizationName,
   organizationType,
   ...props
}: DecorationOrganizationNameCardProps) {
   const theme = useTheme();
   const { t } = useI18n();

   return (
      <DecorationCard width={270} {...props}>
         <Div.row
            alignItems="center"
            gap={theme.styles.gap}
            marginBottom={theme.styles.gap}
            paddingRight={theme.styles.space * 2}
         >
            <Div.row
               width={38}
               height={38}
               alignItems="center"
               justifyContent="center"
               backgroundColor={theme.colors.success}
               borderRadius={theme.styles.borderRadius}
               flexShrink={0}
            >
               <Icon name="house" color={theme.colors.base} />
            </Div.row>

            <Text fontWeight={700}>{organizationName || t((l) => l.components.decorations.organizationName)}</Text>
         </Div.row>

         <Text fontSize={12} color={theme.colors.textSecondary}>
            {organizationType ? t((l) => l.enums.organizationType[organizationType]) : t((l) => l.common.properties)}
         </Text>
      </DecorationCard>
   );
}

export default memo(DecorationOrganizationNameCard);
